import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

export function useAddAction(options = {}) {
	return useMutation(values => axios.post("/action/create", values).then(res => res.data));
}
export function useEditAction(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/action/update", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("action");
			queryClient.removeQueries("action");
		},
	});
}

export function useDeleteAction(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/action/delete", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("action");
			queryClient.removeQueries("action");
		},
	});
}
